import type { RedoMerchantAgentKnowledgeRpcClient } from "@redotech/redo-merchant-agent-knowledge-rpc/client";
import { createRedoMerchantAgentKnowledgeRpcClient } from "@redotech/redo-merchant-agent-knowledge-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoAgentKnowledgeRpcClientContext: Context<
  RedoMerchantAgentKnowledgeRpcClient | undefined
> = createContext<RedoMerchantAgentKnowledgeRpcClient | undefined>(undefined);
RedoAgentKnowledgeRpcClientContext.displayName =
  "RedoAgentKnowledgeRpcClientContext";

export function RedoAgentKnowledgeRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const client = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoMerchantAgentKnowledgeRpcClient({
      baseURL: new URL(`${baseUrl}/agent-knowledge-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoAgentKnowledgeRpcClientContext.Provider value={client}>
      {children}
    </RedoAgentKnowledgeRpcClientContext.Provider>
  );
}
